import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAspectRatio169 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.1992 10C18.1992 9.37881 17.727 8.86827 17.1221 8.80664L16.999 8.7998H6.99902C6.33628 8.7998 5.79883 9.33726 5.79883 10V14C5.79883 14.6627 6.33628 15.2002 6.99902 15.2002H16.999C17.6618 15.2002 18.1992 14.6627 18.1992 14V10ZM19.7988 14C19.7988 15.5464 18.5454 16.7998 16.999 16.7998H6.99902C5.45263 16.7998 4.19922 15.5464 4.19922 14V10C4.19922 8.4536 5.45263 7.2002 6.99902 7.2002H16.999L17.2852 7.21484C18.6971 7.35818 19.7988 8.55021 19.7988 10V14Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgAspectRatio169);
export default ForwardRef;
